/* global localStorage */

import * as MutationTypes from './mutation-types'
import { mapGetters, mapState, mapSetters } from 'vuex'
import dateUtil from "../services/date";
import axios from '../backend/vue-axios'

const getDefaultState = () => {
  return {
    id: false,
    address: [{
      zip: '',
      city: '',
      street: '',
      number: '',
      firstname: '',
      lastname: '',

    }],
    offers: [{
      kravag: '',
    }],
    pricing: {},
    showAcceptContract: false,

    leveling_list: ["0", "1"], //, "2", "3", "4"],
    leveling_type_list: ["", "Z", "E", "L", "N", "D", "O", "H", "B", "C", "I", "F", "V1", "V2", "G1", "G2"],
    is_new_car: false,
    is_insucance: false,
    is_tarriff: false,
    is_car: false,
    is_van: false,

    radio_holder: '',
    radio_usage: '',
    radio_value: '',

    iban: '',
    bic: '',
    kravag_payment_mode: '',
    kravag_payment_mode_select: '',
    insurance_id: '',
    leveling_type: '',
    vsnr: '',
    current_mileage: '',

    state: '',
    kravag_state: '',
    possible_sf_holders_privat: [
      {
        label: 'VN',
        value: '1'
      },
      {
        label: 'Ehe- oder Lebenspartner',
        value: '2'
      }
    ],
    possible_sf_holders_company: [
      {
        label: 'VN',
        value: '1'
      },
    ],
    sf_holder_sf: 0,
    sf_holder_insurance: '',

    // general data
    is_car: false,
    is_van: false,

    participations: [],
    paymentterms: [],

    participation: '',
    paymentterm: '',

    // customer data
    firstname: '',
    lastname: '',
    company_name: '',
    customer_first_name: '',
    customer_last_name: '',
    customer_street: '',
    customer_number: '',
    customer_city: '',
    city: '',
    customer_zip: '',
    is_company: false,
    company_name: '',
    nosf: false,
    customer_sf: 0,
    customer_sf2: 0,
    dob: '',
    has_holder: false,
    holder_id: 'N',
    kravag_location_id: '',
    holder_kravag_location_id: '',
    // holder_zip: '',


    wizard: false,
    // calc data
    holder_only_driver: '',
    youngest_driver_dob: '',
    oldest_driver_dob: '',
    license_date: '',
    insurance_start: '',
    sf_classes_enabled: false,
    customer_has_free_sfr: true,
    has_second_vehicle: 0,
    second_vehicle_holder: '',
    insurance: '',

    // validation
    // offer
    customerValidated: false,
    carValidated: false,
    insuranceValidated: false,
    // contract
    damageKindValidated: false,
    customerAddressValidated: false,
    billingAddressValidated: false,
    inspectionAddressValidated: false,
    lawyerAddressValidated: false,
    carDataValidated: false,
    opponentDataValidated: false,

    allValidated: false,


    holder_firstname: '',
    holder_lastname: '',
    holder_street: '',
    holder_number: '',
    holder_zip: '',
    holder_city: '',


    forgein_bank_owner: '',
    bank_account_owner_firstname: '',
    bank_account_owner_lastname: '',
    forgein_bank_owner_street: '',
    forgein_bank_owner_number: '',
    forgein_bank_owner_zip: '',
    forgein_bank_owner_city: '',

    selected_usage_only_private: false,
    selected_only_driver: false,
    selected_free_sfr: false,
    selected_second_vehicle: false,

    vehicle_weight: 3.5,

    // defaulted data
    new_car_value: 35000,
    new_car_above_max: false,

    // car data
    car_brand: '',
    car_ccm: '',
    car_haftpflicht: 0,
    car_kw: 0,
    car_model: '',
    car_ps: '',
    car_teilkasko: '',
    car_vollkasko: '',
    car_hsn: '',
    car_tsn: '',

    car_mileage: '',
    car_first_registration: '',
    car_registration: '',
    car_usage: '',
    car_usage_only_private: 0,
    show_usage: true,
    hsn: '',
    tsn: '',
    vin: '',
    plate: '',
    mileage: '',
    nationality: '',
    nationality_country: '',
    // if van we need additional info
    vehicle_weight: 0,
    body_id: '',
    car_value: 'Unter 210.000 €',
    edit_car: false,
    title: '',
    enstg: {

      "Z": "Zweitfahrzeugregel / Zweitkradregel (SF 1)",
      "D": "Zweitfahrzeugregel (SF 3)",
      "H": "Zweitfahrzeugregel max. SF 8 -Regel (Min. SF 4)",
      "B": "Angleichungsregelung (Min. SF 9 in KH und VK)",
      "F": "Führerscheinregel (SF 1/2)",
      "E": "Ehegattenregel (SF 1)",
      "L": "Eltern-/Kindregel (SF 1)",
      "N": "ohne Vorvertrag", 
      "C": "Kundenkindregel SF 5",
      "I": "Partnerregel max. SF 8  (Min. SF 4)",
      "O": "Partnerregel (SF 3)",
      "V1": "dasselbe Fahrzeug/derselbe Halter (Versichererwechsel)",
      "V2": "das Fahrzeug und/oder der Halter sind unterschiedlich",
      "V": "Versichererwechsel (dasselbe FZG) [führt zum Auslösen einer eVB-Ü]",
      "G1": "Die Sondereinstufung des Vorversicherers übernehmen",
      "G2": "Übernahme der Sondereinstufung/ nicht dasselbe Fahrzeug und derselbe Halter",
      "Ä": "Übernahme der SF-Klassen von einem Dienstwagen",
      "W": "Fahrzeugwechsel",
      "P": "Tarifumstellung",
    },
    car_values: [
      {
        label: 'Ja',
        value: '211000'
      },
      {
        label: 'Nein',
        value: '35000'
      }
    ],

    car_usages: [
      {
        label: 'privat',
        value: 'privat'
      },
      {
        label: 'gewerblich',
        value: 'gewerblich'
      },
      {
        label: 'privat und gewerblich',
        value: 'privat und gewerblich'
      }
    ],

    KRAVAG_HOLDERS_CAR_PRIVAT: [
      /*
        {
            value: "N",
            label: "Keiner",
        },
        */
      {
        value: "P",
        label: "Ehe-/Lebenspartner",
      },
      {
        value: "K",
        label: "behindertes Kind/behinderter Partner ",
      },
      {
        value: "C",
        label: "Firma",
      },
      {
        value: "L",
        label: "Leasinggeber",
      },
      {
        value: "G",
        label: "Inhaber GbR",
      },
      {
        value: "I",
        label: "Firmeninhaber/Geschäftsführer",
      },
      {
        value: "W",
        label: "Werksangehöriger",
      },
      {
        value: "S",
        label: "Sonstiger",
      }
    ],

    KRAVAG_HOLDERS_CAR_COMPANY: [
      {
        value: "C",
        label: "Firma",
      },
      {
        value: "L",
        label: "Leasinggeber",
      },
      {
        value: "G",
        label: "Inhaber GbR",
      },
      {
        value: "I",
        label: "Firmeninhaber/Geschäftsführer",
      },
      {
        value: "W",
        label: "Werksangehöriger",
      },
      {
        value: "S",
        label: "Sonstiger",
      }
    ],

    KRAVAG_HOLDERS_VAN_PRIVATE: [
      {
        value: "P",
        label: "Ehe-/Lebenspartner",
      },
      {
        value: "K",
        label: "behindertes Kind/behinderter Partner ",
      },
      {
        value: "G",
        label: "Inhaber GbR",
      },
      {
        value: "S",
        label: "Sonstiger",
      }
    ],

    KRAVAG_HOLDERS_VAN_COMPANY: [
      {
        value: "G",
        label: "Inhaber GbR",
      },
      {
        value: "I",
        label: "Firmeninhaber/Geschäftsführer",
      },
      {
        value: "S",
        label: "Sonstiger",
      }
    ],


    KRAVAG_VAN_AUFBAUART: [
      {
        value: "00000",
        label: "sonstiger Aufbau",
      },
      {
        value: "00010",
        label: "Plane und Spriegel",
      },
      {
        value: "00020",
        label: "Kipper",
      },
      {
        value: "00035",
        label: "geschlossener Kasten",
      },
      {
        value: "00045",
        label: "offener Kasten",
      },
      {
        value: "00015",
        label: "Curtainsider/Schiebeplane",
      }
    ],

    KRAVAG_SF_HOLDERS: [
      {
        value: "F",
        label: "Führerscheinregel (SF 1/2)",
      },
      {
        value: "E",
        label: "Ehegattenregel (SF 1)",
      },
      {
        value: "L",
        label: "Eltern-/Kindregel (SF 1)",
      },
      {
        value: "N",
        label: "ohne Vorvertrag",
      },
      {
        value: "C",
        label: "Kundenkindregel SF 5",
      },
      {
        value: "I",
        label: "Partnerregel max. SF 8  (Min. SF 4)",
      },
      {
        value: "O",
        label: "Partnerregel (SF 3)"
      },
    ],

    customer_titles: [
      {
        value: "Herr",
        label: "Herr",
      },
      {
        value: "Frau",
        label: "Frau",
      },
      {
        value: "Divers",
        label: "Divers",
      }
    ],

    // insurance options
    option_schutzbrief: false,
    option_schutzbrief_plus: false,
    option_gap: false,
    option_discount_protection: false,
    option_gap_helvetia: false,
    option_fahrerschutz: false,
    option_kex: false,
    option_owndamage: false,
    option_discount_protection_kh: false,
    option_discount_protection_fv: false,

    price_brut_complete: 0,

    sf_classes: [
      {
        value: "55",
        label: "SF 55",
      },
      {
        value: "51",
        label: "SF 51",
      },
      {
        value: "52",
        label: "SF 52",
      },
      {
        value: "53",
        label: "SF 53",
      },
      {
        value: "54",
        label: "SF 54",
      },
      {
        value: "47",
        label: "SF 47",
      },
      {
        value: "48",
        label: "SF 48",
      },
      {
        value: "49",
        label: "SF 49",
      },
      {
        value: "50",
        label: "SF 50",
      },
      {
        value: "46",
        label: "SF 46",
      },
      {
        value: "45",
        label: "SF 45",
      },
      {
        value: "44",
        label: "SF 44",
      },
      {
        value: "43",
        label: "SF 43",
      },
      {
        value: "42",
        label: "SF 42",
      },
      {
        value: "41",
        label: "SF 41",
      },
      {
        value: "40",
        label: "SF 40",
      },
      {
        value: "39",
        label: "SF 39",
      },
      {
        value: "38",
        label: "SF 38",
      },
      {
        value: "37",
        label: "SF 37",
      },
      {
        value: "36",
        label: "SF 36",
      },
      {
        value: "35",
        label: "SF 35",
      },
      {
        value: "34",
        label: "SF 34",
      },
      {
        value: "33",
        label: "SF 33",
      },
      {
        value: "32",
        label: "SF 32",
      },
      {
        value: "31",
        label: "SF 31",
      },
      {
        value: "30",
        label: "SF 30",
      },
      {
        value: "29",
        label: "SF 29",
      },
      {
        value: "28",
        label: "SF 28",
      },
      {
        value: "27",
        label: "SF 27",
      },
      {
        value: "26",
        label: "SF 26",
      },
      {
        value: "25",
        label: "SF 25",
      },
      {
        value: "24",
        label: "SF 24",
      },
      {
        value: "23",
        label: "SF 23",
      },
      {
        value: "22",
        label: "SF 22",
      },
      {
        value: "21",
        label: "SF 21",
      },
      {
        value: "20",
        label: "SF 20",
      },
      {
        value: "19",
        label: "SF 19",
      },
      {
        value: "18",
        label: "SF 18",
      },
      {
        value: "17",
        label: "SF 17",
      },
      {
        value: "16",
        label: "SF 16",
      },
      {
        value: "15",
        label: "SF 15",
      },
      {
        value: "14",
        label: "SF 14",
      },
      {
        value: "13",
        label: "SF 13",
      },
      {
        value: "12",
        label: "SF 12",
      },
      {
        value: "11",
        label: "SF 11",
      },
      {
        value: "10",
        label: "SF 10",
      },
      {
        value: "9",
        label: "SF 9",
      },
      {
        value: "8",
        label: "SF 8",
      },
      {
        value: "7",
        label: "SF 7",
      },
      {
        value: "6",
        label: "SF 6",
      },
      {
        value: "5",
        label: "SF 5",
      },
      {
        value: "4",
        label: "SF 4",
      },
      {
        value: "3",
        label: "SF 3",
      },
      {
        value: "2",
        label: "SF 2",
      },
      {
        value: "1",
        label: "SF 1",
      },
      {
        value: "0.5",
        label: "SF 1/2",
      },
      {
        value: "0",
        label: "SF 0",
      },
      {
        value: "0.2",
        label: "SF M",
      },
    ].reverse(),



  }
}

const state = getDefaultState()

const getters = {
}

const actions = {
  resetOffer({ commit }) {
    commit('resetState')
  },
  fetchOffer({ commit }, token) {
    axios.get("/spa/offers/" + token).then((response) => {
      commit('setOfferItems', response.data.offer);
    })
      .catch((e) => {
        console.log(e);
      });
  },
  saveContract({ commit }, offer) {
    axios.post("/spa/offers/", { offer }).then((response) => {
      console.log(response.data.offer);
      commit('setOfferItems', response.data.offer);
    })
      .catch((e) => {
        console.log(e);
      });
  },
}

const mutations = {
  setOfferItems(state, offerData) {
    console.log("YEHA!");
    console.log(offerData);
    Object.assign(state, offerData);
  },
  setOffer(state, item) {
    state = item;
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
